if (!customElements.get("product-reviews-region")) {
  class ProductReviewsRegion extends HTMLElement {
    connectedCallback() {
      this.desktopTarget = this.querySelector("[data-product-reviews-desktop-target]");
      this.widget = this.desktopTarget?.firstElementChild;
      this.mobileTarget = this.closest(".product")?.querySelector("[data-product-reviews-mobile-target]");
      this.mobileQuery = window.matchMedia("(max-width: 749px)");
      this.updateTarget = this.updateTarget.bind(this);

      if (!this.widget) return;

      this.mobileQuery.addEventListener("change", this.updateTarget);
      this.updateTarget();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener("change", this.updateTarget);
    }

    updateTarget() {
      const target = this.mobileQuery.matches && this.mobileTarget
        ? this.mobileTarget
        : this.desktopTarget;

      if (target && this.widget.parentElement !== target) {
        target.appendChild(this.widget);
      }
    }
  }

  customElements.define("product-reviews-region", ProductReviewsRegion);
}
